class TupleDictionaryService {
    constructor($rootScope, $log) {
        this.$scope = $rootScope;
        this.$log = $log;
        this.dict = {} ;
        };

    tupleToString(tuple) {
        return tuple.join(",");
    }

    init() {  
        this.dict = {};
    }
    
    put(tuple, value) {
        this.dict[this.tupleToString(tuple)] = value;
    }

    get(tuple) {
        return this.dict[this.tupleToString(tuple)];
    }

    remove(tuple) {
        delete this.dict[this.tupleToString(tuple)];
    }

};

angular.module('webcomm').service('tupleDictionaryService', ['$rootScope', '$log', TupleDictionaryService]);
